export const FIRST_PURCHASE = 'first-purchase';
export const RENEWAL = 'renewal';

export type PaymentContext = typeof FIRST_PURCHASE | typeof RENEWAL;
